import React, { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

// Importá componentes visuales
import TituloPagina from "../../components/comunes/TituloPagina";
import Footer from "../../components/comunes/Footer";
import TablaEmpleadosInternos from "../../components/EmpleadosInternos/TablaEmpleadosInternos";
import logo from "../../assets/img/logo.png";
import { getToken } from "../../utils/auth";


const EmpleadosInternos = () => {
    const { darkMode } = useContext(DarkModeContext);
    const [cargando, setCargando] = useState(false);

    const navigate = useNavigate();
    const apiUrlToken = process.env.REACT_APP_API_TOKEN; // tu endpoint para validar token

    useEffect(() => {
        const verificarToken = async () => {
            const token = getToken();

            if (!token) {
                manejarRespuestaNoAutorizada();
                return;
            }

            setCargando(true);
            try {
                const response = await fetch(apiUrlToken, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ Token: token }),
                });

                if (response.ok) {
                    const data = await response.json();
                    // El "8" lo cambiás por el valor que corresponda a tu lógica
                    if (data !== 8) {
                        manejarAccesoDenegado();
                    }
                } else {
                    if (response.status === 401) {
                        manejarRespuestaNoAutorizada();
                    }
                }
            } catch (error) {
                // Error de conexión, lo podés loggear o mostrar alerta
            }
            setCargando(false);
        };

        // Redirecciona al login y recarga la página
        const redireccionar = () => {
            navigate("/");
            window.location.reload();
        };

        const manejarRespuestaNoAutorizada = () => {
            sessionStorage.removeItem("token");
            Swal.fire({
                title: "Sesión expirada o token inválido.",
                text: "Inicie sesión nuevamente.",
                imageUrl: logo,
                imageWidth: 100,
                imageHeight: 30,
                imageAlt: "Logo",
                confirmButtonText: "Ok",
                timer: 5000,
                allowOutsideClick: true,
                customClass: {
                    container: darkMode
                        ? "swal2-container--dark"
                        : "swal2-container--light",
                    confirmButton: "my-swal-button",
                },
            }).then(redireccionar);
        };

        const manejarAccesoDenegado = () => {
            Swal.fire({
                title: "Acceso denegado.",
                text: "No tiene permisos para ingresar.",
                imageUrl: logo,
                imageWidth: 100,
                imageHeight: 30,
                imageAlt: "Logo",
                confirmButtonText: "Ok",
                timer: 5000,
                allowOutsideClick: true,
                customClass: {
                    container: darkMode
                        ? "swal2-container--dark"
                        : "swal2-container--light",
                    confirmButton: "my-swal-button",
                },
            }).then(redireccionar);
        };

        verificarToken();
    }, [darkMode, navigate, apiUrlToken]);

    return (
        <div className="d-flex flex-column min-vh-100" translate="no">
            <div className="pt-5">
                <TituloPagina title="Empleados Internos" />
            </div>
            <div className="pt-2 flex-grow-1">
                <TablaEmpleadosInternos />
            </div>
            <div className="py-4 mt-auto">
                <Footer />
            </div>
        </div>
    );
};

export default EmpleadosInternos;
